export default "__VITE_ASSET__nPo$syuL__"